export const calculateDistance = (path) => {
  if (!path || path.length < 2) return 0

  let totalDistance = 0
  for (let i = 1; i < path.length; i++) {
    const prev = path[i - 1]
    const curr = path[i]

    const R = 6371000 // Earth's radius in meters
    const dLat = ((curr.lat - prev.lat) * Math.PI) / 180
    const dLng = ((curr.lng - prev.lng) * Math.PI) / 180
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((prev.lat * Math.PI) / 180) *
        Math.cos((curr.lat * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distance = R * c

    totalDistance += distance
  }

  return Math.round(totalDistance)
}
